import React from 'react';

import { Icon } from '@chakra-ui/react';

export const ObjectStorageIcon = props => (
  <Icon viewBox="0 0 32 32" w="full" h="full" color="inherit" {...props}>
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeWidth={1}
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M28 13.25h-24c-0.414 0-0.75 0.336-0.75 0.75s0.336 0.75 0.75 0.75v0h1.821l3.353 15.41c0.076 0.34 0.375 0.59 0.732 0.59 0 0 0 0 0 0h12.188c0 0 0.001 0 0.001 0 0.357 0 0.656-0.25 0.731-0.585l0.001-0.005 3.354-15.41h1.82c0.414 0 0.75-0.336 0.75-0.75s-0.336-0.75-0.75-0.75v0zM21.49 29.25h-10.979l-3.156-14.5h17.291zM6.779 10.752h0.001c0.414 0 0.749-0.335 0.75-0.749v-0c-0.002-0.059-0.003-0.127-0.003-0.197 0-2.498 1.384-4.673 3.427-5.8l0.034-0.017c1.417-0.785 3.107-1.247 4.904-1.247 1.806 0 3.502 0.466 4.976 1.285l-0.052-0.027c2.063 1.142 3.437 3.306 3.437 5.791 0 0.074-0.001 0.147-0.004 0.22l0-0.011c0 0 0 0.001 0 0.001 0 0.414 0.336 0.75 0.75 0.75s0.749-0.335 0.75-0.749v-0c0.002-0.059 0.002-0.129 0.002-0.199 0-3.040-1.67-5.689-4.143-7.080l-0.041-0.021c-1.639-0.914-3.595-1.451-5.676-1.451-2.072 0-4.020 0.533-5.714 1.47l0.061-0.031c-2.529 1.415-4.211 4.077-4.211 7.131 0 0.063 0.001 0.127 0.002 0.19l-0-0.009c0 0 0 0.001 0 0.001 0 0.414 0.335 0.749 0.749 0.75h0z"
    ></path>
  </Icon>
);
